module.exports = "/static/assets/e9ae6dc958d4dcf32971dc199d130aac.gif";